import React from 'react';

import SaveSessionToLibrary from '../../calendar/calendar-dialogs/SaveSessionToLibrary';
import DeleteDialog from './dialogs/DeleteDialog';
import ExerciseCreateDrawer from './drawers/ExerciseCreateDrawer';
import CircuitCreateDrawer from './drawers/CircuitCreateDrawer';
import SchemeCreateDrawer from './drawers/SchemeCreateDrawer';
import SupersetCreateDrawer from './drawers/SupersetCreateDrawer';

import Console from '../../../lib/debug';

const DesignerDialogs = () => {
    Console.render('designer.DesignerDialogs');

    return (
        <div>
            <ExerciseCreateDrawer />;
            <CircuitCreateDrawer />;
            <SaveSessionToLibrary />;
            <SchemeCreateDrawer />;
            <SupersetCreateDrawer />
            <DeleteDialog />
        </div>
    );
};

export default DesignerDialogs;
